module.exports = __webpack_public_path__ + "static/media/logout.63d5276a.svg";